// src/Components/FarePopup.js
import React from 'react';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Badge } from '../UI/Card';
import Button from '../UI/Button';

const FarePopup = ({ show, onClose, fares = [], searchToken }) => {
  const navigate = useNavigate();
  const journeyType = localStorage.getItem('tripType')
  const fareList = fares?.FareList || (Array.isArray(fares) ? fares : []);

  const handleBook = (selectedFare, fareData) => {
    localStorage.setItem('selectedFlight', JSON.stringify(fareData));
    localStorage.setItem('fareSummery', JSON.stringify(selectedFare));
    localStorage.setItem('selectedOnwardFlight', JSON.stringify(fareData));
    onClose(); // Close the modal
    navigate('/flight-details', {
      state: { SelectedFare: selectedFare, FareData: fareData, journeyType,fares }
    });
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      size="lg"
      centered
      dialogClassName="custom-modal-width"
      contentClassName="rounded-2xl border-0 overflow-hidden"
    >
      <Modal.Header closeButton className="border-0 px-6 pt-6 pb-0">
        <Modal.Title className="text-xl font-bold text-ink-900">Fare Options</Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-6 pb-6 pt-4">
        {!fareList || fareList.length === 0 ? (
          <div className="text-center py-10 text-ink-400 text-sm">No fare options available</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {fareList.map((fare, index) => (
              <div
                key={index}
                className="rounded-2xl border border-ink-100 shadow-card p-5 flex flex-col"
              >
                <div className="flex items-start justify-between mb-2">
                  <div className="text-xl font-bold text-ink-900">
                    &#8377;{fare?.Fare?.BaseFare}
                  </div>
                  {fare?.IsRefundable ? (
                    <Badge tone="success">Refundable</Badge>
                  ) : (
                    <Badge tone="ink">Non-Refundable</Badge>
                  )}
                </div>

                <h6 className="font-bold text-ink-900 mb-0">{fare?.CabinClass || 'Economy'}</h6>
                <p className="text-ink-400 text-xs mb-3">{fare?.FareType || 'Publish'}</p>

                <div className="border-t border-ink-100 pt-3 mb-3">
                  <p className="text-xs font-bold text-ink-500 uppercase tracking-wide mb-2">Baggage</p>
                  <p className="text-sm text-emerald-600 mb-1">
                    &#10003; Cabin: {fare?.SeatBaggage?.[0]?.[0]?.Cabin === 'Included' ? '7 KG' : fare?.SeatBaggage?.[0]?.[0]?.Cabin || '7 KG'}
                  </p>
                  <p className="text-sm text-emerald-600">
                    &#10003; Check-In: {fare?.SeatBaggage?.[0]?.[0]?.CheckIn === '0 KG' ? '20 KG' : fare?.SeatBaggage?.[0]?.[0]?.CheckIn || '20 KG'}
                  </p>
                </div>

                <div className="border-t border-ink-100 pt-3 mb-3">
                  <p className="text-xs font-bold text-ink-500 uppercase tracking-wide mb-2">Flexibility</p>
                  {fare?.IsRefundable ? (
                    <>
                      <p className="text-sm text-emerald-600 mb-1">&#10003; Refundable with charges</p>
                      <p className="text-sm text-amber-600">&#9888; Date change fees apply</p>
                    </>
                  ) : (
                    <>
                      <p className="text-sm text-ink-500 mb-1">&#10007; Non-refundable</p>
                      <p className="text-sm text-ink-500">&#10007; Date change fees apply</p>
                    </>
                  )}
                </div>

                <div className="border-t border-ink-100 pt-3 mb-4 flex-1">
                  <p className="text-xs font-bold text-ink-500 uppercase tracking-wide mb-2">Seats &amp; More</p>
                  <p className="text-xs text-ink-400 mb-1">
                    Seats Available: {fare?.SeatBaggage?.[0]?.[0]?.NoOfSeatAvailable || 'Limited'}
                  </p>
                  <p className="text-sm text-emerald-600">&#10003; Free Seat Selection</p>
                </div>

                <Button
                  variant="primary"
                  className="w-full"
                  onClick={() => handleBook(fare, fares)}
                >
                  Book Now
                </Button>
              </div>
            ))}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default FarePopup;
